import React from 'react';

const DeckContext = React.createContext();

export default DeckContext;
